import apiCore from '../../utils/api-core';

export function getGroup(groupId) {
	return apiCore.get(`/api/v1/groups/${groupId}`);
}

export function updateGroup(groupId, group) {
    return apiCore.put(`/api/v1/groups/${groupId}`, group);
}

export function deleteContactsInGroup(groupId, contacts) {
    return apiCore.put(`/api/v1/groups/${groupId}/contacts`, contacts);
}

export function addContactsToGroup(groupId, contacts) {
    return apiCore.post(`/api/v1/groups/${groupId}/contacts`, contacts);
}

export function saveGroup(data) {
    return apiCore.post('/api/v1/groups', data);
}

export function deleteGroup(groupId) {
    return apiCore.delete(`/api/v1/groups/${groupId}`);
}

export function checkGroup(groupName) {
    return apiCore.post(`/api/v1/groups/check`, groupName);
}

// user email groups

export function saveEmailGroup(data) {
    return apiCore.post('/api/v1/email-groups', data);
}

export function getAllEmailGroups(){
    return apiCore.get('/api/v1/email-groups');
}

export function deleteEmailGroup(id) {
	return apiCore.delete(`/api/v1/email-groups/${id}`);
}

export function getEmailGroupById(id){
    return apiCore.get(`/api/v1/email-groups/${id}`);
}

export function updateEmailGroup(groupId, group) {
    return apiCore.put(`/api/v1/email-groups/${groupId}`, group);
}

export function getEmailGroupsByCompany(id){
    return apiCore.get(`/api/v1/company/email-groups/${id}`);
}

// v3 Groups API
export function getCompanyGroups(companyId, contactId) {
    var url = `/api/v3/groups/company/${companyId}`;
    if (contactId) {
        url += `?contactId=${contactId}`;
    }
    return apiCore.get(url);
}

export function addContactToGroups(contactId, groupIds) {
    return apiCore.post(`/api/v3/contact/${contactId}/groups`, { groupIds: groupIds });
}

export function removeContactFromGroups(contactId, groupIds) {
    return apiCore.delete(`/api/v3/contact/${contactId}/groups`, { groupIds: groupIds });
}

export function syncContactGroups(contactId, addGroupIds, removeGroupIds) {
    return apiCore.post(`/api/v3/contact/${contactId}/groups/sync`, { add: addGroupIds, remove: removeGroupIds });
}

// v3 Group Detail APIs
export function getGroupV3(groupId) {
    return apiCore.get(`/api/v3/groups/${groupId}`);
}

export function updateGroupV3(groupId, data) {
    return apiCore.put(`/api/v3/groups/${groupId}`, data);
}

export function deleteGroupV3(groupId) {
    return apiCore.delete(`/api/v3/groups/${groupId}`);
}

export function archiveGroupV3(groupId) {
    return apiCore.post(`/api/v3/groups/${groupId}/archive`);
}

export function getGroupContactsV3(groupId, params) {
    return apiCore.get(`/api/v3/groups/${groupId}/contacts`, { params: params });
}

export function addGroupContactsV3(groupId, contactIds) {
    return apiCore.post(`/api/v3/groups/${groupId}/contacts`, { contacts: contactIds });
}

export function removeGroupContactsV3(groupId, contactIds) {
    return apiCore.delete(`/api/v3/groups/${groupId}/contacts`, { contacts: contactIds });
}

export function duplicateGroupV3(groupId, data) {
    return apiCore.post(`/api/v3/groups/${groupId}/duplicate`, data);
}

export function exportGroupV3(groupId) {
    return apiCore.get(`/api/v3/groups/${groupId}/export`);
}

export function createGroupV3(data) {
    return apiCore.post('/api/v3/groups', data);
}